import InfiniteScroll from "infinite-scroll";
import gsap from "gsap";
import StickyButton from "../components/stickyButton";
import Modal from "../components/modal";

class References {
  constructor() {
    this.filters();
    this.infinityScroll();
  }

  filters() {
    const postsList = window.wrapper.querySelector('.references__row');
    const filtersEls = window.wrapper.querySelectorAll('.filters__inner');
    const loadMoreWrapper = window.wrapper.querySelector('.load-more-wrapper');
    const loadMorebutton = loadMoreWrapper.querySelector('a');
    const statuses = window.wrapper.querySelectorAll('.page-load-status > p');
    const maxPerPage = parseInt(postsList.dataset.maxPerPage, 10);

    [].forEach.call(filtersEls, (/** @type {HTMLSelectElement} */ select) => {
      select.addEventListener('change', (e) => {
        e.preventDefault();
        e.stopPropagation();

        [].forEach.call(filtersEls, (filtersEl) => {
          if (filtersEl.id !== select.id) {
            filtersEl.value = -1;
          }
        });

        // Disabled during ajax load
        if(select.classList.contains('disabled'))
          return;

        select.classList.add('disabled');
        select.disabled = true;
        postsList.classList.add('loading');

        const selected = select.options[select.selectedIndex];

        // Ajax Request
        const loadPostsAjaxUrl = `${siteVars.ajaxUrl
        }?action=get_posts`
          + `&post_type=reference`
          + `&reference-sector=${  selected.value}`;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', loadPostsAjaxUrl);
        xhr.onload = () => {
          if (xhr.status === 200) {
            postsList.innerHTML = xhr.response;
            const items = postsList.querySelectorAll('.references__col');

            References.initReferencesHover(items);
            window.lazyLoad.update();
            this.infiniteScroll.destroy();

            const newLink = selected.dataset.href;
            window.history.pushState("", "", newLink);

            if(loadMoreWrapper){
              loadMorebutton.href = `${newLink}page/2`;

              if(parseInt(selected.dataset.total, 10) >= maxPerPage){
                loadMoreWrapper.classList.remove('hide');
                loadMorebutton.style.display = '';
              } else {
                loadMoreWrapper.classList.add('hide');
              }

              [].forEach.call(statuses, (status) => {
                status.style.display = 'none';
              });

              this.infinityScroll();
            }

            gsap.fromTo(items, {
              autoAlpha: 0,
              y: 50
            },{
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              ease: 'power4.out',
              stagger: 0.1,
              delay: 0.1
            });

            select.classList.remove('disabled');
            select.disabled = false;
            postsList.classList.remove('loading');
          }
        };
        xhr.send();

        return false;
      });
    });
  }

  infinityScroll() {
    const container = window.wrapper.querySelector('.references__row');
    this.infiniteScroll = new InfiniteScroll(container, {
      path: '.load-more',
      button: '.load-more',
      append: '.references__col',
      scrollThreshold: false,
      status: '.page-load-status',
      onInit() {
        this.on('append', (response, path, items) => {
          window.lazyLoad.update();
          // reinit modal after loading new posts
          Modal.init();

          gsap.fromTo(items, {
            autoAlpha: 0,
            y: 50
          },{
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: 'power4.out',
            stagger: 0.1,
            delay: 0.1,
            clearProps: "all"
          });

          References.initReferencesHover(items);
        });
      }
    });
  }

  static initReferencesHover(items){
    [].forEach.call(items, (item) => {
      const links = item.querySelectorAll('a');
      [].forEach.call(links, (link) => {
        link.addEventListener('mousemove', window.bgReveal);
        const posttype = link.dataset.type ? link.dataset.type : null;
        link.addEventListener('mouseenter', () => window.cursor.enter(posttype));
        link.addEventListener('mouseleave', () => window.cursor.leave(posttype));
      });

      const buttons = item.querySelectorAll('.button--anim');
      [].forEach.call(buttons, (button) => {
        return new StickyButton(button);
      });
    });
  }

  removeListeners() {
    if (this.infiniteScroll) {
      this.infiniteScroll.destroy();
    }
  }
}

export default References;
